import React from "react";

/**
 * Read-only visual star bar (0–5, supports half stars).
 */
export const StarsDisplay = ({ value = 0, count = 0, showCount = true }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    const cls =
      value >= i ? "s f" : value >= i - 0.5 ? "s h" : "s";
    stars.push(
      <span key={i} className={cls}>
        ★
      </span>
    );
  }
  return (
    <span className="yt-stars" title={`${value.toFixed(2)} / 5`}>
      {stars}
      {showCount ? (
        <span style={{ color: "#666", marginLeft: 6, fontSize: 11 }}>
          ({count.toLocaleString()} ratings)
        </span>
      ) : null}
    </span>
  );
};

/**
 * Interactive 5-star rating widget.
 */
export const RateStars = ({ value = 0, onRate, testIdRoot = "yt-rate-stars" }) => {
  const [hover, setHover] = React.useState(0);
  const display = hover || value;
  return (
    <div
      className="yt-rate"
      data-testid={testIdRoot}
      onMouseLeave={() => setHover(0)}
    >
      {[1, 2, 3, 4, 5].map((n) => (
        <span
          key={n}
          className={`star ${display >= n ? "on" : ""}`}
          data-testid={`yt-star-btn-${n}`}
          onMouseEnter={() => setHover(n)}
          onClick={() => onRate?.(n)}
          role="button"
          aria-label={`Rate ${n} stars`}
        >
          ★
        </span>
      ))}
    </div>
  );
};
